import React, { Component } from 'react'

import { connect } from 'react-redux'

import './index.scss'

class HelpText extends Component {

  constructor (props) {
    super(props)
    this.state = {
      show: false
    }
    this.togglePortal = this.togglePortal.bind(this)
  }

  togglePortal (e) {
    e.preventDefault()
//    this.setState({
//      show: !this.state.show
//    })

    if (!this.state.show) {
      this.setState({
        show: true
      })
      window.setTimeout(() => { window.addEventListener('click', this.togglePortal) }, 10)
    } else {
      window.removeEventListener('click', this.togglePortal)
      window.setTimeout(() => {
        this.setState({
          show: false
        })
      }, 10)
    }
  }

  render () {
    let extraClass = ''
    let transparentClass = ''
    if (this.props.left) {
      extraClass += 'leftText'
    }
    if (this.props.bottom) {
      extraClass += 'bottomText'
    }
    let imgsrc = '/images/icons/Cirkle_info-grey10x10px.png'
    // let imgsrc = '/images/svgs/Cirkle_info-white.svg'
    let newClass = 'svg10'
    if (this.props.larger) {
      imgsrc = '/images/icons/Cirkle_info-grey25x25px.png'
      transparentClass = 'transp'
      newClass = ''
    }
    if (this.props.green) {
      imgsrc = '/images/icons/Cirkle_info-green10x10px.png'
      newClass = ''
    }
    if (this.props.red) {
      imgsrc = '/images/icons/Cirkle_info-red10x10px.png'
      newClass = ''
    }
    if (this.props.black) {
      imgsrc = '/images/icons/Cirkle_info-Black.png'
      newClass = 'svg10'
    }
    if (this.props.white) {
      imgsrc = '/images/svgs/Cirkle_info-white.svg'
      newClass = 'svg10'
    }
    if (this.props.screen && this.props.screen === 'workcard') {
      imgsrc = '/images/svgs/Cirkle_info-black.svg'
      transparentClass = 'transparentHelper'
      newClass = ''
      // console.log('test')
    }
    return (
      <div className={'helpText ' + extraClass}>
        <span className={transparentClass} onClick={this.togglePortal}><img className={newClass} src={imgsrc} /></span>
        {this.state.show && (
          <div className='helperTextModal' style={this.props.style} onClick={this.togglePortal}>
            <img src='/images/icons/close_24-Black.png' />
            {this.props.text}
          </div>
        )}
      </div>
    )
  }

}

HelpText.defaultProps = {
  style: {}
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {

})(HelpText)



// WEBPACK FOOTER //
// ./src/app/shared/components/HelpText/index.js